import PropTypes from 'prop-types';

export const ItemRegex = /(\$!?\{?item\.(\w+\}?))/gm;

export const ButtonShape = PropTypes.shape({
	inventoryType: PropTypes.string,
	inventoryClassification: PropTypes.string,
	account: PropTypes.string,
	device: PropTypes.string,
	position: PropTypes.string,
	type: PropTypes.string,
	btnHref: PropTypes.string,
	btnStyle: PropTypes.string,
	btnTarget: PropTypes.string,
	btnClasses: PropTypes.string,
	btnAttributes: PropTypes.shape({}),
	btnLabel: PropTypes.string,
	btnSize: PropTypes.string,
	btnTagName: PropTypes.string,
	btnDisabled: PropTypes.bool,
	btnIcon: PropTypes.string,
	btnIconSize: PropTypes.string,
	btnIconContent: PropTypes.string,
	btnIconAfter: PropTypes.bool,
	image: PropTypes.string,
	hoverImage: PropTypes.string,
	backgroundColor: PropTypes.string,
	backgroundHoverColor: PropTypes.string,
	textColor: PropTypes.string,
	textHoverColor: PropTypes.string,
	pageAliases: PropTypes.string,
	showOnListings: PropTypes.bool,
	showOnDetails: PropTypes.bool,
	params: PropTypes.shape({})
});

export const ButtonPropertyDefaults = {
	inventoryType: 'both',
	inventoryClassification: 'all',
	account: null,
	device: 'both',
	position: 'pricing',
	type: 'button',
	btnHref: '',
	btnStyle: 'default',
	btnTarget: null,
	btnClasses: null,
	btnAttributes: {},
	btnLabel: '',
	btnSize: 'default',
	btnTagName: 'a',
	btnDisabled: false,
	btnIcon: null,
	btnIconSize: null,
	btnIconContent: null,
	btnIconAfter: false,
	image: null,
	hoverImage: null,
	backgroundColor: null,
	backgroundHoverColor: null,
	textColor: null,
	textHoverColor: null,
	pageAliases: null,
	showOnListings: true,
	showOnDetails: true,
	params: {}
};

export const VehicleShape = {
	vin: PropTypes.string,
	uuid: PropTypes.string,
	make: PropTypes.string,
	year: PropTypes.string,
	windowStickerUrl: PropTypes.string,
	warrantyDescription: PropTypes.string,
	stockNumber: PropTypes.string,
	modelCode: PropTypes.string,
	msrp: PropTypes.string,
	categoryName: PropTypes.string,
	model: PropTypes.string,
	trim: PropTypes.string,
	odometer: PropTypes.string,
	images: PropTypes.string,
	type: PropTypes.string,
	bodyStyle: PropTypes.string,
	globalVehicleId: PropTypes.string,
	certified: PropTypes.string,
	accountName: PropTypes.string,
	accountCity: PropTypes.string,
	accountState: PropTypes.string,
	accountZipcode: PropTypes.number,
	accountId: PropTypes.string,
	internetPrice: PropTypes.number
};

export const VehicleDefaults = {
	vin: null,
	uuid: null,
	make: null,
	year: null,
	windowStickerUrl: null,
	warrantyDescription: null,
	stockNumber: null,
	modelCode: null,
	msrp: null,
	categoryName: null,
	model: null,
	trim: null,
	odometer: null,
	images: null,
	type: null,
	classification: null,
	bodyStyle: null,
	globalVehicleId: null,
	certified: null,
	accountName: null,
	accountCity: null,
	accountState: null,
	accountZipcode: 0,
	accountId: null,
	internetPrice: 0
};



// WEBPACK FOOTER //
// ./src/global-constants.js